import { Checkbox, Typography } from "@mui/material";

import { HighlightedDetailField } from "../../../components";
import { useStationListWithCache } from "../../../components/StationHookFormSelect";

import {
  FieldGrid,
  TableBodyRow,
  TableHeaderRow,
  TableShell,
} from "../styles";
import { BilingualTitle, Section, SectionSubHeader } from "../components";

const grindGates = ["Flush", "Witness"];
const checkboxProps = { disabled: true, sx: { padding: 0 } };
const POST_COLS = "60px 80px 1.5fr 1fr 1.5fr";

const PartPostFoundry = ({ section = {} }) => {
  const config = section?.config || {};
  const routing = section?.routing || [];
  const { stations = [] } = useStationListWithCache();

  return (
    <Section
      icon="CheckCircle"
      label="Finishing Department"
      spanishLabel="Acabado"
    >
      <SectionSubHeader
        label="Post Foundry Routing"
        spanishLabel="Rutas de Acabado"
      />
      <TableShell>
        <TableHeaderRow columns={POST_COLS}>
          <BilingualTitle label="#" spanishLabel="#" size="sm" />
          <BilingualTitle label="Outside" spanishLabel="Externo" size="sm" />
          <BilingualTitle label="Station" spanishLabel="Estación" size="sm" />
          <BilingualTitle label="Partner" spanishLabel="Proveedor" size="sm" />
          <BilingualTitle label="Notes" spanishLabel="Notas" size="sm" />
        </TableHeaderRow>
        {routing.map((row, idx) => {
          const cfg = row?.config || {};
          const station = row?.stationId
            ? stations.find((s) => s.id === row.stationId)
            : null;
          return (
            <TableBodyRow key={row.id ?? idx} columns={POST_COLS}>
              <Typography variant="caption" sx={{ fontWeight: 600 }}>
                {idx + 1}.
              </Typography>
              <Checkbox checked={!!cfg?.isOutside} {...checkboxProps} />
              <Typography variant="caption">{station?.label ?? "—"}</Typography>
              <Typography variant="caption">{cfg?.partnerId ?? "—"}</Typography>
              <Typography variant="caption">{row?.notes || "—"}</Typography>
            </TableBodyRow>
          );
        })}
      </TableShell>

      <SectionSubHeader
        label="Post Foundry Details"
        spanishLabel="Detalles del Acabado"
      />
      <FieldGrid columns={2}>
        <HighlightedDetailField
          label="Gates"
          spanishLabel="Puertas"
          value={config?.gates}
        />
        <HighlightedDetailField
          label="Grind Gate"
          spanishLabel="Tipo de Pulido"
          value={grindGates[config?.flushWitness - 1]}
        />
      </FieldGrid>

      <SectionSubHeader label="Notes" spanishLabel="Notas" />
      <HighlightedDetailField
        label="Notes"
        spanishLabel="Notas"
        value={section?.notes}
      />
    </Section>
  );
};

export default PartPostFoundry;
